import { Result } from "../model/Result";
import axiosCilent from "./axiosClient";

//スタッフ系は Firebase auth に登録するため authApi
const authApi = {

  requestPortalUserToken: async (tenantId: string, userId: string, password: string)
    : Promise<Result> => {
    try {
      const requestData = {
        userId: userId,
        tenantId: tenantId,
        passCode: password
      }
      const response = await axiosCilent.post(`getPortalUserToken`, requestData);
      return {success: true, data: response.data};
    } catch (error) {
      return {success: false, data: error};
    }
  }
};

export default authApi;
